//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.NCGroupBuilder.js";
import "../CAM/CAM.InheritableFeedBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[0,"MachinePartOccurrence",1,"Assemblies.Component",0],[1,"RapidFeed",0,"CAM.InheritableFeedBuilder",0],[1,"ToolChangeTime",0,"CAM.InheritableDoubleBuilder",0]],[[[],"UpdateToolPathTime",{},0,0],[[],"RemoveMachine",{},0,1],[[],"RemoveKinematics",{},0,1],[["retrieveFlag","ncmctPartMountingBuilder"],"UpdateCamSetup",{},2,1],[["retrieveFlag","ncmctPartMountingBuilder"],"ReplaceMachine",{},2,0]],[]];
SPLM.CAM.MachineGroupBuilder = class extends SPLM.CAM.NCGroupBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MachineGroupBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.MachineGroupBuilder.RetrieveToolPocketInformation = Object.freeze({
    "No" : "No", "Yes" : "Yes"});

export default SPLM;